import styled from "styled-components";
import theme from "../../styles/theme";

export const RowContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: row;
  overflow-y: auto;
  @media ${theme.devices.tablet} {
  }
`;
export const ColumnContainer = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  @media ${theme.devices.tablet} {
  }
`;
